import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropInstagramPosts(slug?: string) {
    return useQuery({
        queryKey: ["drop-instagram-posts", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentInstagramPosts({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 60 * 60 * 1000,
    });
}
